import { ChangeEvent } from 'react';
import { Modal } from 'react-bootstrap';
import { Button } from '@Components/Button';
import { BPMFileInput } from '@Components/BPMFileInput/BPMFileInput';
import { Appearance, Design } from '@Components/designConstants';

interface ImportModalProps {
  importFunction: () => void;
  file?: File;
  setFile: (file?: File) => void;
  onClose: () => void;
}

export const ImportModal = ({ importFunction, file, setFile, onClose }: ImportModalProps) => (
  <Modal show keyboard={false} onHide={onClose}>
    <Modal.Header closeButton>
      <Modal.Title>Import File</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <BPMFileInput
        id='adOpsImportFileInput'
        name='adOpsImportFileInput'
        buttonText='Choose File'
        onChange={(e: ChangeEvent<HTMLInputElement>) => setFile(e.target.files?.[0])}
      />
      <div className='ad-ops-import-file-name'>{file ? file.name : 'No file selected'}</div>
    </Modal.Body>
    <Modal.Footer>
      <Button appearance={Appearance.OUTLINED} design={Design.NEUTRAL} onClick={onClose}>
        Cancel
      </Button>
      <Button
        disabled={!file}
        onClick={() => {
          importFunction();
          onClose();
        }}
      >
        Import
      </Button>
    </Modal.Footer>
  </Modal>
);
